module.exports = __webpack_public_path__ + "static/media/S31_W.efb85e5e.png";